const escapeRegExp = (search: string) => {
  // regex pattern that matches special characters and replaces them with their escaped versions
  return search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

const processMatches = (source: string, searchTerms: any[], bgModifier: any) => {
  if (!source || searchTerms.length === 0) {
    return source
  }

  const pattern = searchTerms.map(escapeRegExp).join('|')
  const regexp = new RegExp(`(${pattern})`, 'gi')
  const parts = source.split(regexp)
  return parts
    .map((part) => {
      if (!part) {
        return ''
      }
      const isMatch = searchTerms.some(term => part.toLowerCase() === term.toLowerCase())
      if (isMatch) {
        return bgModifier
          ? `<span style="background-color: yellow">${part}</span>`
          : `<strong>${part}</strong>`
      }
      return part
    })
    .join('')
}

const updateContent = (el: any, bindings: any) => {
  const source = el.innerText
  const search = bindings.value

  const searchTerms = (Array.isArray(search) ? search : [search]).filter(item => item !== '')
  if (searchTerms.length === 0) return

  const bgModifier = bindings?.modifiers?.bg
  const output = processMatches(source, searchTerms, bgModifier)

  el.innerHTML = output
}
export default {
  bind: (el: any, bindings: any) => updateContent(el, bindings),
  componentUpdated: (el: any, bindings: { oldValue: any, value: any }) => {
    if (bindings.oldValue !== bindings.value) updateContent(el, bindings)
  }
}
